import React from 'react';
import PropTypes from 'prop-types';
import SessionStore from 'stores/shared/session';
import { t, loadLocales } from 'services/translation';

import './index.scss';

export const CheckoutError = ({
  title = 'Oops',
  message = 'Error message',
  showButton = true,
  buttonUrl,
}) => {
  const i18n = SessionStore.state.get('i18n');
  loadLocales(i18n);

  const buttonClick = () => {
    if (buttonUrl) {
      window.location = buttonUrl;
    } else {
      // reload by default if no buttonUrl provided
      window.location.reload();
    }
  };

  const renderButton = () => (
    <div className="GlobalError-ButtonContainer">
      <button
        onClick={buttonClick}
        className="ui button brand-bg"
        type="button"
      >
        {t('GO_BACK')}
      </button>
    </div>
  );

  return (
    <div className="GlobalError-Container">
      <div className="GlobalError-Message">
        <h1>{title}</h1>
        <p>{message}</p>
      </div>
      {showButton && renderButton()}
    </div>
  );
};

CheckoutError.propTypes = {
  title: PropTypes.string,
  message: PropTypes.string,
  showButton: PropTypes.bool,
  buttonUrl: PropTypes.string,
};
